module.exports = __webpack_public_path__ + "static/media/YourStoryOurStory-411x93px@2x.232ccb1e.webp";